import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import DashboardPreview from './components/DashboardPreview';
import AccurateResults from './components/AccurateResults';
import HowItWorks from './components/HowItWorks';
import EngineeringIntelligence from './components/EngineeringIntelligence';
import About from './components/About';
import APIAccessForm from './components/APIAccessForm';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Security from './components/Security';
import Compliance from './components/Compliance';
import InfrastructureHealthDataPolicy from './components/InfrastructureHealthDataPolicy';

// Main website component
const MainWebsite = () => (
  <>
    {/* Hero Section - Landing */}
    <section aria-labelledby="hero-heading">
      <Hero />
    </section>

    {/* Features Section */}
    <section aria-labelledby="features-heading">
      <ValueProposition />
    </section>

    {/* Dashboard Preview Section */}
    <section aria-labelledby="dashboard-heading">
      <DashboardPreview />
    </section>

    {/* Accurate Results Section */}
    <section aria-labelledby="accurate-results-heading">
      <AccurateResults />
    </section>

    {/* How It Works Section */}
    <section aria-labelledby="how-it-works-heading">
      <HowItWorks />
    </section>

    {/* Engineering Intelligence Section */}
    <section aria-labelledby="engineering-intelligence-heading">
      <EngineeringIntelligence />
    </section>

    {/* About Section */}
    <section aria-labelledby="about-heading">
      <About />
    </section>

    {/* API Access Form Section */}
    <section aria-labelledby="api-access-heading">
      <APIAccessForm />
    </section>
  </>
);

// Layout component for pages with navigation and footer
const Layout = ({ children }) => (
  <div className="App" itemScope itemType="https://schema.org/WebPage">
    {/* Skip to main content link for accessibility */}
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary-600 text-white px-4 py-2 rounded-lg z-50"
    >
      Skip to main content
    </a>

    <Navigation />

    <main id="main-content" role="main">
      {children}
    </main>

    <Footer />
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Legal Pages - With navigation and footer but extra top padding */}
        <Route path="/privacy-policy" element={
          <Layout>
            <PrivacyPolicy />
          </Layout>
        } />
        <Route path="/terms-of-service" element={
          <Layout>
            <TermsOfService />
          </Layout>
        } />
        <Route path="/security" element={
          <Layout>
            <Security />
          </Layout>
        } />
        <Route path="/compliance" element={
          <Layout>
            <Compliance />
          </Layout>
        } />
        <Route path="/infrastructure-health-data-policy" element={
          <Layout>
            <InfrastructureHealthDataPolicy />
          </Layout>
        } />
        
        {/* Main Website - With navigation and footer */}
        <Route path="/" element={
          <Layout>
            <MainWebsite />
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App; 